import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const ForgotPasswordPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) { setError('이메일을 입력해주세요.'); return; }
    setLoading(true);
    setError('');
    try {
      const res = await fetch('/api/auth/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim() })
      });
      if (res.ok) {
        setSent(true);
      } else {
        const data = await res.json();
        setError(data.detail || '오류가 발생했습니다.');
      }
    } catch {
      setError('네트워크 오류가 발생했습니다.');
    }
    setLoading(false);
  };

  return (
    <>
      <Header />
      <div style={{ minHeight: 'calc(100vh - 300px)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '40px 16px' }}>
        <div style={{ width: '100%', maxWidth: 440, background: '#fff', borderRadius: 16, boxShadow: '0 4px 24px rgba(0,0,0,0.08)', padding: '40px 32px' }}>
          {!sent ? (
            <>
              <h2 style={{ textAlign: 'center', fontSize: 24, fontWeight: 700, color: '#1e293b', marginBottom: 8 }}>비밀번호 찾기</h2>
              <p style={{ textAlign: 'center', color: '#94a3b8', fontSize: 14, marginBottom: 28 }}>
                가입한 이메일 주소를 입력하시면<br />비밀번호 재설정 링크를 보내드립니다.
              </p>
              <form onSubmit={handleSubmit}>
                <label style={{ display: 'block', fontSize: 14, fontWeight: 600, color: '#374151', marginBottom: 6 }}>이메일</label>
                <input
                  type="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  placeholder="example@email.com"
                  style={{
                    width: '100%', padding: '12px 16px', border: '1px solid #d1d5db', borderRadius: 8,
                    fontSize: 15, outline: 'none', boxSizing: 'border-box', marginBottom: 16,
                    transition: 'border-color 0.2s'
                  }}
                  onFocus={e => e.target.style.borderColor = '#FF6B35'}
                  onBlur={e => e.target.style.borderColor = '#d1d5db'}
                  autoFocus
                />
                {error && (
                  <p style={{ color: '#ef4444', fontSize: 13, marginBottom: 12 }}>{error}</p>
                )}
                <button
                  type="submit"
                  disabled={loading}
                  style={{
                    width: '100%', padding: '14px', background: loading ? '#ccc' : '#FF6B35',
                    color: '#fff', border: 'none', borderRadius: 8, fontSize: 16, fontWeight: 700,
                    cursor: loading ? 'wait' : 'pointer', transition: 'background 0.2s'
                  }}
                >
                  {loading ? '발송 중...' : '재설정 링크 발송'}
                </button>
              </form>
              <p style={{ textAlign: 'center', marginTop: 20, fontSize: 14, color: '#94a3b8' }}>
                <Link to="/login" style={{ color: '#FF6B35', textDecoration: 'none', fontWeight: 600 }}>로그인으로 돌아가기</Link>
              </p>
            </>
          ) : (
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: 48, marginBottom: 16 }}>&#9993;</div>
              <h2 style={{ fontSize: 22, fontWeight: 700, color: '#1e293b', marginBottom: 12 }}>이메일을 확인해주세요</h2>
              <p style={{ color: '#64748b', fontSize: 14, lineHeight: 1.6, marginBottom: 8 }}>
                <strong style={{ color: '#1e293b' }}>{email}</strong> 으로<br />
                비밀번호 재설정 링크를 발송했습니다.
              </p>
              <p style={{ color: '#94a3b8', fontSize: 13, marginBottom: 24 }}>
                이메일이 도착하지 않으면 스팸 폴더를 확인해주세요.
              </p>
              <Link to="/login" style={{
                display: 'inline-block', padding: '12px 32px', background: '#FF6B35', color: '#fff',
                borderRadius: 8, textDecoration: 'none', fontSize: 15, fontWeight: 600
              }}>
                로그인으로 돌아가기
              </Link>
            </div>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ForgotPasswordPage;
